<template>
  <b-modal
    id="modal1"
    ref="modal"
    title="検索"
    hide-footer
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @hidden="hideSearchModal"
    size="xl"
  >
    <form ref="form" @submit.prevent="submitAction">
      <div class="form-container">
        <div class="custom-form-block reg-form">
          <div class="form-group row align-items-center">
            <!-- 登録日 -->
            <div class="col-sm-4 d-flex align-items-center">
              <h3 class="col-form-label mr-3" style="min-width: 120px;">
                登録 / 更新日
              </h3>
              <div class="d-flex">
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="fromDateModel"
                  placeholder="From"
                  class="mr-2"
                ></vuejs-datepicker>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="toDateModel"
                  placeholder="To"
                ></vuejs-datepicker>
              </div>
            </div>

            <!-- 年齢 -->
            <div class="col-sm-4 d-flex align-items-center">
              <h3 class="col-form-label mr-3" style="min-width: 50px;">年齢</h3>
              <div class="d-flex align-items-end mr-2">
                <input
                  type="number"
                  class="form-control ageInc-field mr-1"
                  v-model="fromAgeModel"
                  min="0"
                  :class="{ 'is-invalid': errors.fromAgeModel.error }"
                  style="width: 80px;"
                />
                <span class="age-text">歳</span>
              </div>
              <div class="d-flex align-items-end">
                <span class="age-text mr-2">〜</span>
                <input
                  type="number"
                  class="form-control ageInc-field mr-1"
                  v-model="toAgeModel"
                  min="0"
                  :class="{ 'is-invalid': errors.toAgeModel.error }"
                  style="width: 80px;"
                />
                <span class="age-text">歳</span>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mt-2 mb-2">
            <!-- 年収 -->
            <div class="col-sm-4 d-flex align-items-center">
              <h3 class="col-form-label mr-2" style="min-width: 120px;">
                年収
              </h3>
              <div class="d-flex align-items-end mr-2 ml-2">
                <input
                  type="number"
                  class="form-control ageInc-field mr-1"
                  v-model="fromIncomeModel"
                  min="0"
                  :class="{ 'is-invalid': errors.fromIncomeModel.error }"
                  style="width: 100px;"
                />
                <span class="age-text">万円</span>
              </div>
              <div class="d-flex align-items-end">
                <span class="age-text mr-2">〜</span>
                <input
                  type="number"
                  class="form-control ageInc-field mr-1"
                  v-model="toIncomeModel"
                  min="0"
                  :class="{ 'is-invalid': errors.toIncomeModel.error }"
                  style="width: 100px;"
                />
                <span class="age-text">万円</span>
              </div>
            </div>

            <!-- 性別 -->
            <div class="col-sm-4 d-flex align-items-center" style="gap: 20px;">
              <h3 class="col-form-label mr-3" style="min-width: 50px;">性別</h3>
              <div class="form-check mr-3">
                <input
                  type="checkbox"
                  id="male"
                  value="男性"
                  class="form-check-input"
                  v-model="genderModel"
                />
                <label for="male" class="form-check-label">男性</label>
              </div>
              <div class="form-check mr-3">
                <input
                  type="checkbox"
                  id="female"
                  value="女性"
                  class="form-check-input"
                  v-model="genderModel"
                />
                <label for="female" class="form-check-label">女性</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="unspecified"
                  value="指定なし"
                  class="form-check-input"
                  v-model="genderModel"
                />
                <label for="unspecified" class="form-check-label"
                  >指定なし</label
                >
              </div>
            </div>
          </div>

          <div class="form-group row mb-2 mt-2">
            <div class="col-sm-12 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label mr-3" style="min-width: 120px;">
                学歴
              </h3>
              <div
                class="d-flex flex-wrap"
                style="column-gap: 50px; row-gap: 10px;"
              >
                <div
                  v-for="finalEducation in finalEducations"
                  :key="finalEducation.id"
                >
                  <input
                    type="checkbox"
                    :id="finalEducation.id"
                    :value="finalEducation.id"
                    class="form-check-input mr-1"
                    v-model="finalEducationModel"
                  />
                  <label :for="finalEducation.id" class="form-check-label">
                    {{ finalEducation.title }}
                  </label>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-10">

        </div> -->
          </div>

          <div class="form-group row">
            <div class="col-sm-12 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label mr-3" style="min-width: 120px">
                英語力
              </h3>
              <!-- <div class="col-sm-10 ml-3"> -->
              <div
                class="d-flex flex-wrap"
                style="column-gap: 50px; row-gap: 10px;"
              >
                <div
                  v-for="englishSkill in englishSkills"
                  style="max-width: 18% !important;"
                >
                  <input
                    type="checkbox"
                    :id="englishSkill.id"
                    :value="englishSkill.id"
                    class="form-check-input"
                    v-model="englishSkillModel"
                  />
                  <label :for="englishSkill.id" class="form-check-label">{{
                    englishSkill.title
                  }}</label>
                </div>
              </div>
              <!-- </div> -->
            </div>
          </div>

          <div class="form-group row">
            <div class="col-sm-12 d-flex align-items-center" style="gap: 15px">
              <h3 class="col-form-label" style="min-width: 120px">経由</h3>
              <!-- <div class="col-sm-9 ml-2"> -->
              <div class="form-check form-check-inline">
                <input
                  type="checkbox"
                  id="own"
                  value="own"
                  class="form-check-input"
                  v-model="companyModel"
                />
                <label for="own" class="form-check-label">自社HP経由登録</label>
              </div>
              <div class="form-check form-check-inline ml-4">
                <input
                  type="checkbox"
                  id="other"
                  value="other"
                  class="form-check-input"
                  v-model="companyModel"
                />
                <label for="other" class="form-check-label"
                  >他ルート経由登録</label
                >
              </div>
              <!-- </div> -->
            </div>
          </div>

          <!-- <div class="form-group row mb-2">
      <h3 class="col-sm-1"> 性別 </h3>
      <div class="col-sm-10 ml-3">
        <div class="row">
            <div class="col-md-3">
              <input
                type="checkbox"
                id="male"
                value="男性"
                class="form-check-input"
                v-model="genderModel">
              <label for="male" class="form-check-label">男性</label>
            </div>
            <div class="col-md-3">
              <input
                type="checkbox"
                id="female"
                value="女性"
                class="form-check-input"
                v-model="genderModel">
              <label for="female" class="form-check-label">女性</label>
            </div>
            <div class="col-md-3">
              <input
                type="checkbox"
                id="unspecified"
                value="指定なし"
                class="form-check-input"
                v-model="genderModel">
              <label for="unspecified" class="form-check-label">指定なし</label>
            </div>
        </div>
      </div>
    </div> -->

          <div class="form-group row">
            <div class="col-sm-4 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label" style="min-width: 120px;">直近職種</h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleJobClassification('toggle')"
                  href="javascript:void(0)"
                  :class="hasJobsSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  +選択
                </a>
                <!-- <h3>
            <a v-b-toggle="'jobClassification'" href="Javascript:void(0)">直近職種</a>
          </h3> -->
                <b-modal
                  modal-class="custom-inner-modal"
                  id="jobClassification"
                  ref="jobClassificationModal"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  size="huge"
                >
                  <div
                    class="form-group row"
                    style="max-height: 500px;overflow-y:scroll"
                  >
                    <div class="col-md-12">
                      <div
                        class="pl-4"
                        v-for="main in occupations"
                        v-bind:key="main.id"
                      >
                        <input
                          type="checkbox"
                          :id="main.id"
                          :value="main.id"
                          class="form-check-input"
                          v-model="mainJobModel"
                          @click="
                            watchParentJobUncheck(
                              $event,
                              'label' + main.id,
                              main
                            )
                          "
                        />
                        <label
                          :id="'label' + main.id"
                          @click="setLabelClicked"
                          class="form-check-label job-label"
                          >{{ main.title }}</label
                        >
                        <div
                          class="row"
                          v-if="
                            isChecked(main.id) ||
                              isLabelClicked('label' + main.id)
                          "
                        >
                          <div
                            class="col-sm-4"
                            v-for="child in main.children"
                            v-bind:key="child._id"
                          >
                            <div class="form-check form-check-inline">
                              <input
                                type="checkbox"
                                :id="child._id"
                                :value="child._id"
                                class="form-check-input"
                                v-model="childJobModel"
                                @click="manuallyCheckJob($event, main)"
                              />
                              <label
                                :for="child._id"
                                class="form-check-label"
                                >{{ child.title }}</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      data-dismiss="modal"
                      @click="toggleJobClassification('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      id="download"
                      class="btn btn-sm btn-primary search"
                      @click="toggleJobClassification('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
            <div class="col-sm-4 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label" style="min-width: 120px;">居住地</h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleResidence('toggle')"
                  href="javascript:void(0)"
                  :class="hasResidenceSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  +選択
                </a>
                <b-modal
                  ref="residenceModal"
                  id="residence"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                >
                  <div class="row p-2">
                    <div
                      class="col-md-3"
                      v-for="residence in reversedResidences"
                      v-bind:key="residence.id"
                    >
                      <div class="form-check form-check-inline">
                        <input
                          type="checkbox"
                          :id="residence.id"
                          :value="residence.id"
                          class="form-check-input"
                          v-model="residenceModel"
                        />
                        <label :for="residence.id" class="form-check-label">{{
                          residence.title
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      data-dismiss="modal"
                      @click="toggleResidence('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      id="download"
                      class="btn btn-sm btn-primary search"
                      @click="toggleResidence('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>

          <div class="form-group row mt-2">
            <div class="col-sm-12 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label" style="min-width:120px">
                キーワード検索
              </h3>
              <div class="">
                <div class="d-flex form-row mb-2">
                  <!-- <label for="word1" class="col-xs-3 col-form-label">すべてを含む</label> -->
                  <div>
                    <input
                      type="text"
                      id="word1"
                      v-model="wordModel"
                      class="form-control big-query"
                      placeholder="複数キーワードの場合はスペース区切りで入力してください"
                      style="border: 1px solid #b3b3b3;width: 500px;padding:5px; background: #fff;"
                    />
                  </div>
                  <div class="search-options mt-2" style="margin-left: 50px;">
                    <label class="">
                      <input
                        type="radio"
                        v-model="currentSearchType"
                        value="all"
                        name="searchType"
                      />
                      すべてを含む
                    </label>
                    <label class="ml-3">
                      <input
                        type="radio"
                        v-model="currentSearchType"
                        value="any"
                        name="searchType"
                      />
                      いずれかを含む
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="form-group row">
        <div class="col-sm-12">
          <input type="checkbox" name="bigQuery" v-model="bigQueryModel">
          <label for="big_query" id="bigQuery">職務経歴書の中も検索する ※検索結果表示まで時間がかかる事があります</label>
        </div>
      </div> -->

          <div
            class="form-group row align-items-center mt-2"
            style="grid-gap: 10px !important;"
          >
            <div class="col-sm-3 d-flex align-items-center" style="gap: 14px">
              <h3 class="col-form-label mb-0" style="min-width: 120px;">
                スカウト希望
              </h3>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="scouthope"
                  class="form-check-input"
                  v-model="scoutHopeModel"
                />
                <label for="scouthope" class="form-check-label"
                  >スカウト希望</label
                >
              </div>
            </div>

            <!-- スカウト希望日 -->
            <div class="col-sm-4 d-flex align-items-center">
              <h3 class="col-form-label mr-3" style="min-width: 120px;">
                スカウト希望日
              </h3>
              <div class="d-flex" style="min-width: 250px;">
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="scoutedAtFromDateModel"
                  placeholder="From"
                  class="mr-2"
                ></vuejs-datepicker>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="scoutedAtToDateModel"
                  placeholder="To"
                ></vuejs-datepicker>
              </div>
            </div>

            <!-- ブックマーク -->
            <div class="col-sm-4 d-flex align-items-end" style="gap: 14px">
              <h3 class="col-form-label mr-3 mb-0" style="min-width: 60px;">
                ラベル
              </h3>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="bookmarkonly"
                  class="form-check-input"
                  v-model="favoriteModel"
                />
                <label for="bookmarkonly" class="form-check-label"
                  >ブックマークのみ表示</label
                >
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="bookmarkonly"
                  class="form-check-input"
                  v-model="interviewModel"
                />
                <label for="interviewOnly" class="form-check-label"
                  >面接実施</label
                >
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-sm-12 d-flex align-items-center" style="gap: 16px">
              <h3 class="col-form-label" style="min-width: 120px">
                ステータス
              </h3>
              <div
                class="d-flex flex-wrap"
                style="column-gap: 50px; row-gap: 10px;"
              >
                <div
                  v-for="(status, index) in getClientStatus"
                  v-bind:key="index"
                >
                  <div class="form-check form-check-inline">
                    <input
                      type="checkbox"
                      :id="index"
                      :value="status"
                      class="form-check-input"
                      v-model="statusModel"
                    />
                    <label :for="index" class="form-check-label">{{
                      status
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col-sm-4 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label" style="min-width: 120px;">
                確認依頼用リスト
              </h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleReviewList('toggle')"
                  href="javascript:void(0)"
                  :class="hasReviewListSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  +選択
                </a>
                <b-modal
                  modal-class="custom-inner-modal"
                  id="reviewListModal"
                  ref="reviewListModal"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  size="huge"
                >
                  <div
                    class="form-group row"
                    style="max-height: 500px; overflow-y: scroll"
                  >
                    <div class="col-md-12">
                      <div
                        class="pl-4"
                        v-for="(list, index) in getAllReviewLists"
                        v-bind:key="index"
                      >
                        <div class="form-check form-check-inline">
                          <input
                            type="checkbox"
                            :id="list._id"
                            :value="list._id"
                            class="form-check-input"
                            v-model="allReviewListModel"
                          />
                          <label
                            :for="list._id"
                            class="form-check-label job-label"
                            >{{ list.title }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      @click="toggleReviewList('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      class="btn btn-sm btn-primary search"
                      @click="toggleReviewList('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>

            <div class="col-sm-4 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label mb-0" style="min-width: 120px;">
                申込イベント
              </h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleEventList('toggle')"
                  href="javascript:void(0)"
                  :class="hasEventSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  +選択
                </a>
                <b-modal
                  modal-class="custom-inner-modal"
                  id="eventListModal"
                  ref="eventListModal"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  size="huge"
                >
                  <div
                    class="form-group row"
                    style="max-height: 500px; overflow-y: scroll"
                  >
                    <div class="col-md-12">
                      <div
                        class="pl-4"
                        v-for="event in events"
                        v-bind:key="event._id"
                      >
                        <div class="form-check form-check-inline">
                          <input
                            type="checkbox"
                            :id="event._id"
                            :value="event._id"
                            class="form-check-input"
                            v-model="eventModel"
                          />
                          <label
                            :for="event._id"
                            class="form-check-label job-label"
                            >{{ formatDate(event.event_date.from) }},
                            {{ event.event_name }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      @click="toggleEventList('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      class="btn btn-sm btn-primary search"
                      @click="toggleEventList('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal-footer d-flex justify-content-center"
        style="gap: 50px;"
      >
        <button
          type="button"
          class="btn btn-outline-danger search-btn-block btn-white"
          data-dismiss="modal"
          @click="openEditModal"
        >
          {{ editOrCancelText }}
        </button>
        <button
          type="submit"
          @click="submitAction"
          id="download"
          class="btn btn-primary search-btn-block"
          :class="isSearchReflect ? 'btn-blue' : 'btn-red'"
          :disabled="isSubmitting"
        >
          {{ searchText }}
        </button>
      </div>
    </form>
    <b-modal
      ref="searchTitle"
      cancel-variant="outline-danger"
      cancel-title="キャンセル"
      ok-title="保存"
      title="検索条件保存"
      :ok-disabled="isSubmitting"
      modal-class="editSearch"
      hide-footer
      @hidden="hideSearchTitleModal"
    >
      <form data-vv-scope="saveSearchTemplate">
        <div class="custom-form-block search-edit-form" style="padding: 20px;">
          <div class="form-group row" style="grid-gap: 0px !important">
            <div class="col-md-12 mb-30">
              <label>
                検索条件名
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': searchTemplateErrors.title.error,
                }"
                name="title"
                v-model="title"
                v-validate="'required'"
                placeholder="検索条件名を入力"
              />
              <div
                class="invalid-feedback"
                v-if="searchTemplateErrors.title.error"
              >
                <span class="icon-error">!</span>
                {{ searchTemplateErrors.title.msg }}
              </div>
            </div>

            <div class="col-md-12 mb-30">
              <div class="d-flex flex-row">
                <label class="mb-2">
                  ログイン時の初期表示条件にする
                  <span class="text-danger">*</span>
                </label>
                <div class="form-check ml-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="isDefault"
                    id="isDefaultCheck"
                    true-value="yes"
                    false-value="no"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ends custom-form-block -->
      </form>
      <!-- <template #modal-footer> -->
      <div
        class="modal-footer d-flex justify-content-center"
        style="border-top: none;"
      >
        <button class="btn btn-white" @click="hideModal">キャンセル</button>
        <button class="btn btn-blue" @click="saveSearch()">保存する</button>
      </div>
      <!-- </template> -->
    </b-modal>
  </b-modal>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import mutations from '@/config/mutations';
import actions from '@/config/actions';
import datePicker from 'vue-bootstrap-datetimepicker';
import vuejsDatepicker from 'vuejs-datepicker';
import moment from 'moment';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'SearchForm',
  components: { datePicker, vuejsDatepicker },
  props: {
    template: {
      type: Object,
      required: true,
    },
    isSearchReflect: {
      type: Boolean,
    },
  },
  data() {
    return {
      isSubmitting: false,
      title: this.template.title,
      isDefault: this.template.is_default === false ? 'no' : 'yes',
      newTemplate: false,
      searchParams: this.template.search,
      disableFunction: {
        customPredictor(date) {
          if (date > new Date()) {
            return true;
          }
        },
      },
      fromOptions: null,
      toOptions: null,

      childOccupations: [],
      fromDateModel: null,
      toDateModel: null,
      scoutedAtFromDateModel: null,
      scoutedAtToDateModel: null,

      residenceModel: [],
      tempResidence: [],
      tempReviewList: [],
      tempEventlist: [],
      scoutHopeModel: false,
      favoriteModel: null,
      interviewModel: null,
      wordModel: null,
      currentSearchType: null,
      //  wordOne:'',
      //  wordAll:'',
      genderModel: [],
      //  bigQueryModel: null,
      tempChildJobs: [],
      tempMainJobs: [],
      fromAgeModel: null,
      toAgeModel: null,
      fromIncomeModel: null,
      toIncomeModel: null,
      searchTemplateErrors: {
        title: {
          error: false,
          msg: '',
        },
      },
      errors: {
        fromAgeModel: {
          error: false,
          msg: '',
        },
        toAgeModel: {
          error: false,
          msg: '',
        },
        fromIncomeModel: {
          error: false,
          msg: '',
        },
        toIncomeModel: {
          error: false,
          msg: '',
        },
      },
      clickedLabels: [],
      mainClicked: [],
      isJobClassificationOpen: false,
      isResidenceOpen: false,
    };
  },
  watch: {
    //  showModal(val) {
    //    if (val) this.$refs.modal.show();
    //    this.$refs.modal.hide();
    //  },
    fromAgeModel(value) {
      const data = this.fromValidation(value, this.toAgeModel);
      const data1 = this.toValidation(this.toAgeModel, value);
      [this.errors.fromAgeModel.error, this.errors.fromAgeModel.msg] = data;
      [this.errors.toAgeModel.error, this.errors.toAgeModel.msg] = data1;
    },
    toAgeModel(value) {
      const data = this.toValidation(value, this.fromAgeModel);
      const data1 = this.fromValidation(this.fromAgeModel, value);
      [this.errors.toAgeModel.error, this.errors.toAgeModel.msg] = data;
      [this.errors.fromAgeModel.error, this.errors.fromAgeModel.msg] = data1;
    },
    fromIncomeModel(value) {
      const data = this.fromValidation(value, this.toIncomeModel);
      const data1 = this.toValidation(this.toIncomeModel, value);
      [
        this.errors.fromIncomeModel.error,
        this.errors.fromIncomeModel.msg,
      ] = data;
      [this.errors.toIncomeModel.error, this.errors.toIncomeModel.msg] = data1;
    },
    toIncomeModel(value) {
      const data = this.toValidation(value, this.fromIncomeModel);
      const data1 = this.fromValidation(this.fromIncomeModel, value);
      [this.errors.toIncomeModel.error, this.errors.toIncomeModel.msg] = data;
      [
        this.errors.fromIncomeModel.error,
        this.errors.fromIncomeModel.msg,
      ] = data1;
    },
    searchParams(value) {
      this.prepopulateModels();
      if (Object.keys(value).length === 0) {
        this.clearForm();
      }
    },
  },
  created() {
    this.load();
    this.prepopulateModels();
  },
  mounted() {
    // console.log(this.template);
    this.$refs.modal.show();
  },
  computed: {
    searchText() {
      return this.isSearchReflect ? '検索する' : '別名で新規保存';
    },
    editOrCancelText() {
      return this.isSearchReflect ? 'キャンセル' : '上書き保存';
    },

    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    childJobModel: {
      get() {
        return this.getChildJobModel;
      },
      set(value) {
        this.setChildJobModel(value);
      },
    },
    englishSkillModel: {
      get() {
        return this.getEnglishSkillModel;
      },
      set(value) {
        this.setEnglishSkillModel(value);
      },
    },
    finalEducationModel: {
      get() {
        return this.getFinalEducationModel;
      },
      set(value) {
        this.setFinalEducationModel(value);
      },
    },
    resumeModel: {
      get() {
        return this.getResumeModel;
      },
      set(value) {
        this.setResumeModel(value);
      },
    },
    jobSummaryModel: {
      get() {
        return this.getJobSummaryModel;
      },
      set(value) {
        this.setJobSummaryModel(value);
      },
    },
    eventModel: {
      get() {
        return this.getEventModel;
      },
      set(value) {
        this.setEventModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
    allReviewListModel: {
      get() {
        return this.getAllReviewListModel;
      },
      set(value) {
        this.setAllReviewListModel(value);
      },
    },
    companyModel: {
      get() {
        return this.getCompanyModel;
      },
      set(value) {
        this.setCompanyModel(value);
      },
    },
    colorModel: {
      get() {
        return this.getColorModel;
      },
      set(value) {
        this.setColorModel(value);
      },
    },
    reversedResidences() {
      const newResidences = this.residences;
      return newResidences;
      // return newResidences.reverse();
    },
    hasJobsSelected() {
      return this.getMainJobModel.length > 0 || this.getChildJobModel.length > 0;
    },
    hasResidenceSelected() {
      return this.residenceModel.length > 0;
    },
    hasReviewListSelected() {
      return this.getAllReviewListModel.length > 0;
    },
    hasEventSelected() {
      return this.getEventModel.length > 0;
    },
    
    ...mapGetters({
      getActiveCategory: 'getActiveCategory',
      getChildJobModel: 'getChildJobModel',
      getMainJobModel: 'getMainJobModel',
      getEnglishSkillModel: 'getEnglishSkillModel',
      getFinalEducationModel: 'getFinalEducationModel',
      getResumeModel: 'getResumeModel',
      getJobSummaryModel: 'getJobSummaryModel',
      getStatusModel: 'getStatusModel',
      getClientStatus: 'getClientStatus',
      getCompanyModel: 'getCompanyModel',
      getColorModel: 'getColorModel',
      getEventModel: 'getEventModel',
      getEvents: 'getEvents',
      getAllReviewLists: 'getAllReviewLists',
      getAllReviewListModel: 'getAllReviewListModel',
    }),
    ...mapState({
      //    showModal: ({ applicant }) => applicant.showSearchModal,
      residences: ({ applicant }) => applicant.selectors.residences || [],
      occupations: ({ applicant }) => applicant.selectors.occupations || [],
      englishSkills: ({ applicant }) => applicant.selectors.englishSkills || [],
      finalEducations: ({ applicant }) =>
        applicant.selectors.finalEducations || [],
      events: ({ applicant }) => applicant.events || [],
      manuallyCheckedJobs: ({ applicant }) => applicant.manuallyCheckedJobs,
    }),
    form() {
      let main = [...this.getMainJobModel, ...new Set(this.mainClicked)];

      //  let bigQueryOne = this.bigQueryOne.trim().length > 0 ? this.bigQueryOne : null;
      //  let bigQueryAll = this.bigQueryAll.trim().length > 0 ? this.bigQueryAll : null;

      return {
        registrationDateFrom: this.fromDateModel
          ? moment(this.fromDateModel).format('YYYY-MM-DD')
          : null,
        registrationDateTo: this.toDateModel
          ? moment(this.toDateModel).format('YYYY-MM-DD')
          : null,
        ageFrom: this.fromAgeModel,
        ageTo: this.toAgeModel,
        englishSkills: this.englishSkillModel,
        events: this.eventModel,
        residences: this.residenceModel,
        incomeFrom: this.fromIncomeModel,
        incomeTo: this.toIncomeModel,
        word: this.wordModel,
        searchType: this.currentSearchType,
        favorites: this.favoriteModel,
        interview: this.interviewModel,
        scoutHope: this.scoutHopeModel,
        scoutedAtFrom: this.scoutedAtFromDateModel
          ? moment(this.scoutedAtFromDateModel).format('YYYY-MM-DD')
          : null,
        scoutedAtTo: this.scoutedAtToDateModel
          ? moment(this.scoutedAtToDateModel).format('YYYY-MM-DD')
          : null,
        //  word: this.wordModel,
        //  wordOne: this.wordOne,
        //  wordAll: this.wordAll,
        //  bigQuery: this.bigQueryModel,
        childOccupations: this.getChildJobModel,
        mainJobs: [...new Set(main)],
        status: this.statusModel,
        reviewLists: this.allReviewListModel,
        regcompany: this.companyModel,
        client_color: this.colorModel,
        finalEducations: this.finalEducationModel,
        resume: this.resumeModel,
        jobSummary: this.jobSummaryModel,
        gender: this.genderModel,
      };
    },
    checkError() {
      return (
        this.errors.fromAgeModel.error ||
        this.errors.toAgeModel.error ||
        this.errors.fromIncomeModel.error ||
        this.errors.toIncomeModel.error
      );
    },
  },
  methods: {
    ...mapMutations([
      mutations.applicant.TOGGLE_SEARCH_MODAL,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      mutations.applicant.SET_SELECTORS,
      mutations.applicant.SET_EVENTS,
      'mutateSearchTemplateAfterEdit',
      'setEventModel',
      'setBulkActiveCategory',
      'setChildJobModel',
      'setMainJobModel',
      'setEnglishSkillModel',
      'setStatusModel',
      'setCompanyModel',
      'setColorModel',
      'setManuallyCheckedJobs',
      'updateMainJobModel',
      'setAllReviewLists',
      'setAllReviewListModel',
      'setNewTemplate',
      'setFinalEducationModel',
      'setResumeModel',
      'setJobSummaryModel',
    ]),
    ...mapActions([
      actions.applicant.LOAD_SELECTORS,
      actions.applicant.LOAD_EVENTS,
      actions.applicant.LOAD_ALL_REVIEWLIST,
    ]),
    handlejobSummaryChange(value) {
      this.jobSummaryModel = this.jobSummaryModel === value ? null : value;
    },
    handleResumeChange(value) {
      this.resumeModel = this.resumeModel === value ? null : value;
    },
    hideModal() {
      this.isResidenceOpen = false;
      this.isJobClassificationOpen = false;
      this.hideSearchTitleModal();
      this.$emit('hideSearchModal');
    },
    hideSearchTitleModal() {
      this.$refs.searchTitle.hide();
    },
    openEditModal() {
      if (this.isSearchReflect) {
        this.hideModal();
        return;
      }
      this.$refs.searchTitle.show();
    },
    submitAction() {
      if (this.isSearchReflect) {
        this.search();
        return;
      }
      this.newTemplate = true;
      this.$refs.searchTitle.show();
    },
    toggleJobClassification(action) {
      if (action === 'toggle') {
        this.tempChildJobs = this.childJobModel;
        this.tempMainJobs = this.mainJobModel;
        this.$refs.jobClassificationModal.show();
      } else if (action === 'cancel') {
        this.childJobModel = this.tempChildJobs;
        this.mainJobModel = this.tempMainJobs;
        this.$refs.jobClassificationModal.hide();
      } else if (action === 'submit') {
        this.$refs.jobClassificationModal.hide();
      }
    },
    toggleResidence(action) {
      if (action === 'toggle') {
        this.tempResidence = this.residenceModel;
        this.$refs.residenceModal.show();
      } else if (action === 'cancel') {
        this.residenceModel = this.tempResidence;
        this.$refs.residenceModal.hide();
      } else if (action === 'submit') {
        this.$refs.residenceModal.hide();
      }
    },
    toggleReviewList(action) {
      if (action === 'toggle') {
        this.tempReviewList = [...this.allReviewListModel];
        this.$refs.reviewListModal.show();
      } else if (action === 'cancel') {
        this.allReviewListModel = [...this.tempReviewList];
        this.$refs.reviewListModal.hide();
      } else if (action === 'submit') {
        this.$refs.reviewListModal.hide();
      }
    },
    toggleEventList(action) {
      if (action === 'toggle') {
        this.tempEventList = [...this.eventModel];
        this.$refs.eventListModal.show();
      } else if (action === 'cancel') {
        this.eventModel = [...this.tempEventList];
        this.$refs.eventListModal.hide();
      } else if (action === 'submit') {
        this.$refs.eventListModal.hide();
      }
    },
    isChecked(id) {
      if (this.mainJobModel.indexOf(id) !== -1) return true;
      return false;
    },
    formatDate(date) {
      return moment(date)
        .utc()
        .format('YYYY-MM-DD');
    },
    isLabelClicked(id) {
      return this.clickedLabels.indexOf(id) !== -1;
    },
    setLabelClicked(event) {
      let index = this.clickedLabels.indexOf(event.target.id);
      if (index !== -1) {
        this.clickedLabels.splice(index, 1);
      } else {
        this.clickedLabels.push(event.target.id);
      }
    },
    watchParentJobUncheck(event, id, main) {
      let index = this.clickedLabels.indexOf(id);
      let mainIndexId = id.replace('label', '');
      let mainIndex = this.mainClicked.indexOf(mainIndexId);
      mainIndex === -1 && this.mainClicked.push(main.id);
      if (event.target.checked) {
        main.children.forEach((child) => this.childJobModel.push(child._id));
      } else {
        if (index !== -1) {
          this.clickedLabels.splice(index, 1);
        }
        if (mainIndex !== -1) {
          let removed = this.mainClicked.filter((item) => item != mainIndexId);
          this.mainClicked = [...removed];
        }
        const main = this.occupations.find((occ) => mainIndexId === occ.id);
        main.children.forEach((child) => {
          const index = this.childJobModel.indexOf(child._id);
          if (index !== -1) {
            const newChildJobModel = [...this.childJobModel];
            const newManuallyCheckedJobs = [...this.manuallyCheckedJobs];
            newChildJobModel.splice(index, 1);
            newManuallyCheckedJobs.splice(index, 1);
            // Update the state properties with the new arrays
            this.childJobModel = newChildJobModel;
            this.setManuallyCheckedJobs(newManuallyCheckedJobs);
            this.setManuallyCheckedJobs(
              Array.from(new Set(this.manuallyCheckedJobs))
            );
          }
        });
      }
      this.childJobModel = Array.from(new Set(this.childJobModel));
    },
    manuallyCheckJob(event, main) {
      if (event.target.checked) {
        this.manuallyCheckedJobs.push(event.target.id);
        this.childJobModel.push(event.target.id);
        !this.mainClicked.includes(main.id) && this.mainClicked.push(main.id);
      } else {
        let index = this.manuallyCheckedJobs.indexOf(event.target.id);
        let childIndex = this.childJobModel.indexOf(event.target.id);
        const newChildJobModel = [...this.childJobModel];
        newChildJobModel.splice(childIndex, 1);
        this.childJobModel = newChildJobModel;
        if (index !== -1) {
          const newManuallyCheckedJobs = [...this.manuallyCheckedJobs];
          newManuallyCheckedJobs.splice(index, 1);
          this.setManuallyCheckedJobs(newManuallyCheckedJobs);
        }
      }
      let x = this.checkChildCount(main);
      if (x.childCount < 1) {
        let mainJob = this.mainJobModel.indexOf(main.id);
        let mainIndex = this.mainClicked.indexOf(main.id);
        //   let clickedLabelIndex = this.clickedLabels.indexOf(`label${main.id}`);
        this.clickedLabels = this.clickedLabels.filter(
          (item) => item !== `label${main.id}`
        );
        this.mainClicked.splice(mainIndex, 1);
        //  console.log(mainJob);
        if (mainJob !== -1) {
          this.mainJobModel.splice(mainJob, 1);
        }
      }
    },
    checkChildCount(main) {
      let children = main.children.length;
      let childCount = 0;
      for (let i = 0; i < main.children.length; i++) {
        for (let j = 0; j < this.childJobModel.length; j++) {
          // console.log('here');
          if (main.children[i]._id == this.childJobModel[j]) {
            childCount++;
          }
        }
      }
      let childCounts = {
        children,
        childCount,
      };
      return childCounts;
    },
    hideSearchModal() {
      this.clearForm();
      this.$refs.modal.hide();
      this.$emit('hideSearchModal', false);
    },
    scrollToError() {
      const element = document.getElementsByClassName('invalid-feedback')[0];
      if (element) {
        const parent = element.closest('.col-lg-6');
        parent.scrollIntoView();
      }
    },
    //  async saveSearchTemplate() {
    //   this.isSubmitting = true;
    //   const check = await this.$validator.validateAll('saveSearchTemplate');
    //   if (check) {
    //     this.searchTemplateErrors.title.error = false;
    //     this.searchTemplateErrors.title.msg = '';
    //     const params = this.form;

    //     if(this.searchParams.sortBy) Object.assign(params, { sort: this.sortBy });
    //     if(this.searchParams.applicantsCount && this.searchParams.applicantsCount.perPage) {
    //         Object.assign(params, { rowPerPage: this.searchParams.applicantsCount.perPage });
    //     }

    //     Object.keys(params).forEach(key => !params[key] && delete params[key]);

    //     Object.assign(params, { title: this.title, is_default: this.isDefault })
    //     // if (this.sortBy) Object.assign(params, { sort: this.sortBy });
    //     // if (this.applicantsCount.perPage) {
    //     //   Object.assign(params, { rowPerPage: this.applicantsCount.perPage });
    //     // }
    //     ApiService.put(Api.endpoints.EDIT_TEMPLATE(this.template.id), params) // eslint-disable-next-line
    //       .then(({ data }) => {
    //         this.mutateSearchTemplateAfterEdit(data.data);
    //         this.isSubmitting = false;
    //         this.hideModal();
    //         this.hideSearchModal();
    //       })
    //       .catch(({ response }) => {this.parseErrorResponse(response); this.isSubmitting=false});
    //   } else {
    //     this.isSubmitting=false;
    //     this.searchTemplateErrors.title.error = true;
    //     this.searchTemplateErrors.title.msg = '検索条件名は必須項目です';
    //   }
    // },

    //  async saveSearch() {
    //    const params = this.form;
    //    Object.keys(params).forEach(key => !params[key] && delete params[key]);
    //    if(this.searchParams.sortBy) Object.assign(params, { sort: this.sortBy });
    //    if(this.searchParams.applicantsCount && this.searchParams.applicantsCount.perPage) {
    //       Object.assign(params, { rowPerPage: this.searchParams.applicantsCount.perPage });
    //     }
    //    Object.assign(params, { title: this.title, is_default: this.isDefault })

    //    ApiService.put(Api.endpoints.EDIT_TEMPLATE(this.template.id), params) // eslint-disable-next-line
    //     .then(({data}) => {
    //       // console.log(data);
    //       this.mutateSearchTemplateAfterEdit(data.data);
    //       this.hideSearchModal();
    //     })
    //     .catch((error) => {
    //       this.parseErrorResponse(error)
    //     });
    //  },

    async saveSearch() {
      if (this.isSearchReflect) {
        this.search();
        return;
      }
      this.isSubmitting = true;
      const check = this.newTemplate
        ? await this.$validator.validateAll('saveSearchTemplate')
        : true;
      let endpoints;
      let method;
      if (this.newTemplate) {
        endpoints = Api.endpoints.SAVE_SEARCH_TEMPLATE;
        method = 'post';
      } else {
        endpoints = Api.endpoints.EDIT_TEMPLATE(this.template.id);
        method = 'put';
      }
      if (check) {
        this.searchTemplateErrors.title.error = false;
        this.searchTemplateErrors.title.msg = '';
        const params = this.form;

        if (this.searchParams.sortBy)
          Object.assign(params, { sort: this.sortBy });
        // if (this.searchParams.applicantsCount && this.searchParams.applicantsCount.perPage) {
        //   Object.assign(params, { rowPerPage: this.searchParams.applicantsCount.perPage });
        // }

        Object.keys(params).forEach(
          (key) => !params[key] && delete params[key]
        );

        Object.assign(params, {
          title: this.title,
          is_default: this.isDefault,
        });

        Object.assign(params, { isNewPanel: true });

        try {
          // console.log(this.isSubmitting);
          const { data } = await ApiService[method](endpoints, params);
          const postAPICallMutation = this.newTemplate
            ? this.setNewTemplate
            : this.mutateSearchTemplateAfterEdit;

          postAPICallMutation(data.data);
          this.hideSearchModal();
        } catch (error) {
          console.log(error);
          this.parseErrorResponse(error);
        } finally {
          // console.log(this.isSubmitting);
          this.isSubmitting = false;
          this.newTemplate = false;
        }
      } else {
        this.isSubmitting = false;
        this.searchTemplateErrors.title.error = true;
        this.searchTemplateErrors.title.msg = '検索条件名は必須項目です';
      }
    },
    search() {
      if (!this.checkError) {
        const params = this.form;

        Object.keys(params).forEach(
          (key) => !params[key] && delete params[key]
        );
        if (
          this.searchParams.mainJobs &&
          this.searchParams.mainJobs.length > 0
        ) {
          params.mainJobs = this.searchParams.mainJobs;
        }
        this[mutations.applicant.CHANGE_SEARCH_PARAMS](params);
        this.hideSearchModal();
        this.$emit('hideSearchModal', true);
      } else {
        this.scrollToError();
      }
    },
    load() {
      this[actions.applicant.LOAD_SELECTORS]()
        .then(({ data }) => {
          this[mutations.applicant.SET_SELECTORS](data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));

      this[actions.applicant.LOAD_EVENTS]()
        .then(({ data }) => {
          this[mutations.applicant.SET_EVENTS](data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));

      this[actions.applicant.LOAD_ALL_REVIEWLIST]()
        .then(({ data }) => {
          this.setAllReviewLists(data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
    fromValidation(valueModel, model) {
      let error = '';
      let msg = '';
      if (valueModel === '' || valueModel === null) {
        error = false;
        msg = '';
        return [error, msg];
      }
      if (model !== '' && model !== null) {
        if (valueModel < 0) {
          error = true;
          // msg = 'value cannot be less than 0.';
          msg = '入力データが正しくありません。';
          return [error, msg];
        }
        if (valueModel <= parseFloat(model)) {
          error = false;
          msg = '';
          return [error, msg];
        }
        if (model < 0) {
          error = false;
          msg = '';
          return [error, msg];
        }
        error = true;
        // msg = `value must be less or equals to ${model}.`;
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      if (valueModel < 0) {
        error = true;
        // msg = 'value cannot be less than 0.';
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      error = false;
      msg = '';
      return [error, msg];
    },
    toValidation(valueModel, model) {
      let error = '';
      let msg = '';
      if (valueModel === '' || valueModel === null) {
        error = false;
        msg = '';
        return [error, msg];
      }
      if (model !== '' && model !== null) {
        if (valueModel < 0) {
          error = true;
          // msg = 'value cannot be less than 0.';
          msg = '入力データが正しくありません。';
          return [error, msg];
        }
        if (valueModel >= parseFloat(model)) {
          error = false;
          msg = '';
          return [error, msg];
        }
        error = true;
        // msg = `value must be greater or equals to ${model}.`;
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      if (valueModel < 0) {
        error = true;
        // msg = 'value cannot be less than 0.';
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      error = false;
      msg = '';
      return [error, msg];
    },
    prepopulateModels() {
      this.toIncomeModel = this.searchParams.incomeTo
        ? this.searchParams.incomeTo
        : this.toIncomeModel;
      this.fromIncomeModel = this.searchParams.incomeFrom
        ? this.searchParams.incomeFrom
        : this.fromIncomeModel;
      this.toAgeModel = this.searchParams.ageTo
        ? this.searchParams.ageTo
        : this.toAgeModel;
      this.fromAgeModel = this.searchParams.ageFrom
        ? this.searchParams.ageFrom
        : this.fromAgeModel;
      // this.tempMainJobs = [];
      this.childJobModel = this.searchParams.childOccupations
        ? this.searchParams.childOccupations
        : this.childJobModel;
      // this.mainJobModel = this.searchParams.mainJobs ? this.searchParams.mainJobs : this.mainJobModel;
      //  this.wordModel = this.searchParams.word ? this.searchParams.word : this.wordModel;

      this.wordModel = this.searchParams.word
        ? this.searchParams.word
        : this.wordModel;
      this.currentSearchType = this.searchParams.currentSearchType
        ? this.searchParams.currentSearchType
        : this.currentSearchType;

      this.favoriteModel = this.searchParams.favorites
        ? this.searchParams.favorites
        : this.favoriteModel;
      
        this.interviewModel = this.searchParams.interviews
        ? this.searchParams.interviews
        : this.interviewModel;

      this.scoutHopeModel = this.searchParams.scoutHope || this.scoutHopeModel;

      this.scoutedAtFromDateModel = this.searchParams.scoutedAtFrom
        ? this.searchParams.scoutedAtFrom
        : this.scoutedAtFromDateModel;
      this.scoutedAtToDateModel = this.searchParams.scoutedAtTo
        ? this.searchParams.scoutedAtTo
        : this.scoutedAtToDateModel;

      this.residenceModel = this.searchParams.residences
        ? this.searchParams.residences
        : this.residenceModel;
      this.englishSkillModel = this.searchParams.englishSkills
        ? this.searchParams.englishSkills
        : this.englishSkillModel;
      (this.eventModel = this.searchParams.events
        ? this.searchParams.events
        : this.eventModel),
        (this.toDateModel = this.searchParams.registrationDateTo
          ? this.searchParams.registrationDateTo
          : this.toDateModel);
      this.fromDateModel = this.searchParams.registrationDateFrom
        ? this.searchParams.registrationDateFrom
        : this.fromDateModel;
      this.statusModel = this.searchParams.status
        ? this.searchParams.status
        : this.statusModel;
      this.companyModel = this.searchParams.regcompany
        ? this.searchParams.regcompany
        : this.companyModel;
      this.colorModel = this.searchParams.client_color
        ? this.searchParams.client_color
        : this.colorModel;
      this.allReviewListModel = this.searchParams.reviewLists
        ? this.searchParams.reviewLists
        : this.getAllReviewListModel;
      this.finalEducationModel = this.searchParams.finalEducations
        ? this.searchParams.finalEducations
        : this.finalEducationModel;
      this.resumeModel = this.searchParams.resume
        ? this.searchParams.resume
        : this.resumeModel;
      this.jobSummaryModel = this.searchParams.jobSummary
        ? this.searchParams.jobSummary
        : this.jobSummaryModel;
      this.genderModel = this.searchParams.gender
        ? this.searchParams.gender
        : this.genderModel;
      // this.setManuallyCheckedJobs([]);
      // this.clickedLabels = [];
      this.searchParams.mainJobs &&
        this.searchParams.mainJobs.forEach((item) => {
          this.clickedLabels.push('label' + item);
        });
      // this.searchParams.childOccupations && this.setManuallyCheckedJobs(this.searchParams.childOccupations);
    },
    clearForm() {
      this.errors = {
        fromAgeModel: {
          error: false,
          msg: '',
        },
        toAgeModel: {
          error: false,
          msg: '',
        },
        fromIncomeModel: {
          error: false,
          msg: '',
        },
        toIncomeModel: {
          error: false,
          msg: '',
        },
      };
      this.toIncomeModel = null;
      this.fromIncomeModel = null;
      this.toAgeModel = null;
      this.fromAgeModel = null;
      this.tempMainJobs = [];
      this.childJobModel = [];
      this.mainJobModel = [];
      this.tempChildJobs = [];
      this.mainClicked = [];
      this.tempResidence = [];
      this.wordModel = null;
      this.currentSearchType = null;
      (this.scoutHopeModal = false),
        (this.favoriteModel = null),
        (this.interviewModel = null),
        (this.residenceModel = []);
      this.englishSkillModel = [];
      (this.eventModel = []), (this.toDateModel = null);
      this.fromDateModel = null;
      this.scoutedAtFromDateModel = null;
      this.scoutedAtToDateModel = null;
      this.statusModel = [];
      this.companyModel = [];
      this.colorModel = [];
      this.setManuallyCheckedJobs([]);
      this.clickedLabels = [];
      this.allReviewListModel = [];
      this.jobSummaryModel = [];
      this.finalEducationModel = [];
      this.resumeModel = [];
      this.genderModel = [];
    },
  },
};
</script>

<style scoped>
.form-group.row {
  grid-gap: 150px;
}


/* Job selection styling */
.job-select-link {
  color: #3c3c3c;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
}

.job-selected-badge {
  color: #006C6B;
  background-color: transparent;
  border: 3px solid #006C6B;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
}

.job-selected-badge:hover {
  text-decoration: none;
  background-color: rgba(32, 178, 170, 0.1);
}

.search-btn-block {
  min-width: 145px !important;
  height: 40px !important;
  padding: 0px !important;
}

.sm-button {
  border: 1px solid red;
  color: red;
}
>>> .btn-sm {
  font-size: 12px;
  padding: 10px;
  border-radius: 5px;
}

>>> .form-group {
  margin-bottom: 0px;
}
>>> .form-group .col-sm-5 {
  padding: 0px;
}

>>> .form-group .col-sm-9 {
  padding: 0px;
}

>>> .custom-form-block.search-edit-form label {
  color: #3c3c3c !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

>>> .custom-form-block .form-control {
  border-bottom: 1px solid #b3b3b3 !important;
}

>>> .custom-form-block input.form-control::placeholder {
  color: #b4b2b2 !important;
  font-size: 14px;
}

>>> .custom-form-block label {
  color: #3c3c3c !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

>>> .age-text {
  width: 40px;
  color: #3c3c3c;
  font-weight: 400;
}

.form-container {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 78vh;
}

>>> .reg-form {
  margin: auto;
  width: 75vw;
  /* overflow-y: scroll;
  overflow-x: hidden;
  max-height: 78vh; */
}

>>> .ageInc-field {
  width: 180px;
}

.reg-form h3,
.form-group h3 {
  text-transform: uppercase;
  color: #3c3c3c;
  font-weight: 600;
  font-size: 13px;
  padding: 0px;
  margin-bottom: 0px;
}

.reg-form h3 a,
.form-group h3 a {
  text-transform: uppercase;
  color: #3c3c3c;
  font-weight: 600;
  font-size: 13px;
}

>>> .reg-form #bigQuery {
  text-transform: uppercase;
  color: #2bb2ab !important ;
  font-weight: 600 !important;
  font-size: 13px !important;
  margin-left: 5px;
  margin-bottom: 8px;
  margin-top: 5px;
}

.reg-form h3 a:hover,
.reg-form h3 a:focus {
  color: #1b7c77;
}

.reg-form .form-check-inline {
  margin-bottom: 7px;
}

.reg-form .form-check-inline .form-check-input {
  margin-top: -2px;
}

.mb-20 {
  margin-bottom: 20px;
}
.modal-content {
  background-color: #fbfcff;
}
.modal-search .modal-title {
  font-size: 15px;
  font-weight: 600;
}

.modal-search .modal-header,
.modal-search .modal-footer {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.sub-head {
  color: #89969f;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 7px;
  padding-top: 10px;
}
.btn-rmv {
  background: transparent;
  padding-right: 15px;
  font-size: 20px;
  color: #31bab4;
  border: none;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
  cursor: pointer;
  z-index: 99;
}
/* .bnt-grp button */

/* job label */
.job-label font {
  pointer-events: none;
}

.job-label:hover {
  text-decoration: underline;
}
</style>
